import { render, staticRenderFns } from "./CurrentRentalWifiRouter.vue?vue&type=template&id=89b24a0a&scoped=true&"
import script from "./CurrentRentalWifiRouter.vue?vue&type=script&lang=ts&"
export * from "./CurrentRentalWifiRouter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b24a0a",
  null
  
)

export default component.exports